export const API_BASE = (
  process.env.REACT_APP_API_URL ||
  "https://procurapi-backend-production-73cd.up.railway.app"
).replace(/\/$/, "");

export function apiRequest(path, options = {}) {
  const { token, headers = {}, ...requestOptions } = options;
  const authorization = token ? { Authorization: `Bearer ${token}` } : {};
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  return fetch(`${API_BASE}${normalizedPath}`, {
    ...requestOptions,
    headers: {
      ...authorization,
      ...headers,
    },
  });
}
